import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-filter-view',
  templateUrl: './filter-view.component.html',
  styleUrls: ['./filter-view.component.scss']
})
export class FilterViewComponent implements OnInit {
  @Input() dropdownListBO: any[] = [];
  @Input() selectedItemsBO: any[] = [];
  @Input() dropdownListOrderCluster: any[] = [];
  @Input() selectedItemsOrderCluster: any[] = [];
  @Input() dropdownListCustomer: any[] = [];
  @Input() selectedItemsCustomer: any[] = [];
  @Input() dropdownListCountry: any[] = [];
  @Input() selectedItemsCountry: any[] = [];
  @Input() dropdownListMonth: any[] = [];
  @Input() selectedItemsMonth: any[] = [];
  @Input() dropdownListYear: any[] = [];
  @Input() selectedItemsYear: any[] = [];
  @Input() dropdownListOrderType: any[] = [];
  @Input() selectedItemsOrderType: any[] = [];
  @Input() customerOfCountry: Map<string, string[]>;
  @Input() orderTypeOfOrderCLuster: Map<string, string[]>;
  @Input() idLeadGlobalOfCustomerName: Map<string, string[]>;
  dropdownSettings: IDropdownSettings = {};
  @Input() selectedItemsIdGlobal: any[] = [];

  @Output() sendFilterEvent = new EventEmitter<any>();

  @Input() dropdownListLead: any[] = [];
  @Input() selectedItemsLead: any[] = [];
  @Input() dropdownListOrderStatus: any[] = [];
  @Input() selectedItemsOrderStatus: any[] = [];
  @Input() viewOrderStatus: boolean;

  @Output() updateFilterEvent = new EventEmitter<any>();
  @Output() changeFilterEvent = new EventEmitter<any>();

  @Input() viewMonth: boolean;
  @Input() overviewOrderdDetailReportSpan: boolean;
  @Input() slaKpiSpan: boolean;
  @Input() completedDetailSpan: boolean;

  constructor() { }

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'Reset',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      enableCheckAll: false
    };
  }

  onChangeSingleCountry(event: any) {
    this.selectedItemsOrderType = [];
    this.selectedItemsOrderStatus = [];
    this.updateFiltersEvent();
  }





  changeDropdownCustomerAfterChangeCountry() {
    this.selectedItemsCustomer = [];
    let customerArray: any[] = [];
    if (this.selectedItemsCountry && this.selectedItemsCountry.length > 0) {
      for (let country of this.selectedItemsCountry) {
        let key: string = country.item_id;
        if (this.customerOfCountry) {
          let arrayCust = this.customerOfCountry.get(key);
          if (Array.isArray(arrayCust)) {
            for (let customer of arrayCust) {
              let data: any = {
                item_id: customer,
                item_text: customer
              }
              let cust = customerArray.find(x => x.item_id == data.item_id);
              if (!cust) {
                customerArray.push(data);
              }

            }
          }
        }
      }
    }
    this.selectedItemsCustomer = customerArray;
    this.updateFiltersEvent();
  }

  onChangeSingleCustomer(event: any) {
    this.selectedItemsBO = [];
    this.selectedItemsCountry = [];
    this.selectedItemsOrderType = [];
    this.selectedItemsOrderStatus = [];
    this.initCustomerIdGlobal();
    this.updateFiltersEvent();
  }





  changeDropdownCountryAfterChangeCustomer() {
    this.selectedItemsCountry = [];
    let countryArray: any[] = [];
    if (this.selectedItemsCustomer && this.selectedItemsCustomer.length > 0) {
      for (let customer of this.selectedItemsCustomer) {
        let valore: string = customer.item_id;
        if (this.customerOfCountry) {
          for (let [key, value] of this.customerOfCountry) {
            if (Array.isArray(value)) {
              let customerSelected = value.find(x => x == valore);
              if (customerSelected) {
                let countryToPush = countryArray.find(x => x.item_id == key);
                if (!countryToPush) {
                  let data: any = {
                    item_id: key,
                    item_text: key
                  }
                  countryArray.push(data);
                }
              }
            }
          }
        }
      }
    }
    this.selectedItemsCountry = countryArray;
  }

  onChangeSingleMonth(event: any) {
    this.selectedItemsOrderCluster = [];
    this.selectedItemsLead = [];
    this.selectedItemsCustomer = [];
    this.selectedItemsBO = [];
    this.selectedItemsCountry = [];
    this.selectedItemsOrderType = [];
    this.selectedItemsOrderStatus = [];
    this.updateFiltersEvent();
  }





  changeDropdownYearAfterChangeMonth() {
    let arrayYear: any[] = [];
    if (this.selectedItemsMonth && this.selectedItemsMonth.length > 0
      && this.selectedItemsYear.length == 0) {
      let year: string = this.getCurrentYear();
      let data: any = {
        item_id: year,
        item_text: year
      }
      arrayYear.push(data);
    }
    this.selectedItemsYear = arrayYear;
  }

  getCurrentYear(): string {
    const currentYear = new Date().getFullYear();
    return String(currentYear);
  }

  onChangeSingleCluster(event: any) {
    this.selectedItemsLead = [];
    this.selectedItemsCustomer = [];
    this.selectedItemsBO = [];
    this.selectedItemsCountry = [];
    this.selectedItemsOrderType = [];
    this.selectedItemsOrderStatus = [];
    this.changeDropdownOrderTypeAfterChangeOrderCluster();
    this.updateFiltersEvent();
  }





  changeDropdownOrderTypeAfterChangeOrderCluster() {
    this.selectedItemsOrderType = [];
    let clusterArray: any[] = [];
    if (this.selectedItemsOrderCluster && this.selectedItemsOrderCluster.length > 0) {
      for (let cluster of this.selectedItemsOrderCluster) {
        let key: string = cluster.item_id;
        if (this.orderTypeOfOrderCLuster) {
          let arrayType = this.orderTypeOfOrderCLuster.get(key);
          if (Array.isArray(arrayType)) {
            for (let orderType of arrayType) {
              let data: any = {
                item_id: orderType,
                item_text: orderType
              }
              let clust = clusterArray.find(x => x.item_id == data.item_id);
              if (!clust) {
                clusterArray.push(data);
              }

            }
          }
        }
      }
    }
    this.selectedItemsOrderType = clusterArray;
  }

  onChangeSingleOrderType(event: any) {
    this.selectedItemsOrderStatus = [];
    this.changeDropdownOrderClusterAfterChangeOrderType();
    this.updateFiltersEvent();
  }





  changeDropdownOrderClusterAfterChangeOrderType() {
    this.selectedItemsOrderCluster = [];
    let clusterArray: any[] = [];
    if (this.selectedItemsOrderType && this.selectedItemsOrderType.length > 0) {
      for (let orderType of this.selectedItemsOrderType) {
        let valore: string = orderType.item_id;
        if (this.orderTypeOfOrderCLuster) {
          for (let [key, value] of this.orderTypeOfOrderCLuster) {
            if (Array.isArray(value)) {
              let orderTypeSelected = value.find(x => x == valore);
              if (orderTypeSelected) {
                let clusterToPush = clusterArray.find(x => x.item_id == key);
                if (!clusterToPush) {
                  let data: any = {
                    item_id: key,
                    item_text: key
                  }
                  clusterArray.push(data);
                }
              }
            }
          }
        }
      }
    }
    this.selectedItemsOrderCluster = clusterArray;
  }

  onChangeSingleYear(event: any) {
    this.selectedItemsMonth = [];
    this.selectedItemsOrderCluster = [];
    this.selectedItemsLead = [];
    this.selectedItemsCustomer = [];
    this.selectedItemsBO = [];
    this.selectedItemsCountry = [];
    this.selectedItemsOrderType = [];
    this.selectedItemsOrderStatus = [];
    if (this.selectedItemsYear && this.selectedItemsYear.length == 0) {
      let array: any[] = [];
      let data: any = {
        item_id: this.getCurrentYear(),
        item_text: this.getCurrentYear()
      }
      array.push(data);
      this.selectedItemsYear = array;
    }
    this.updateFiltersEvent();
  }





  changeDropdownMonthAfterChangeYear() {
    if (this.selectedItemsYear && this.selectedItemsYear.length == 0) {
      this.selectedItemsMonth = [];
    }
  }

  loadReport() {
    let data: any = {
      selectedItemsOrderCluster: this.selectedItemsOrderCluster,
      selectedItemsYear: this.selectedItemsYear,
      selectedItemsMonth: this.selectedItemsMonth,
      selectedItemsCountry: this.selectedItemsCountry,
      selectedItemsCustomer: this.selectedItemsCustomer,
      selectedItemsOrderType: this.selectedItemsOrderType,
      selectedItemsBO: this.selectedItemsBO,
      selectedItemsIdGlobal: this.selectedItemsIdGlobal,
      selectedItemsLead: this.selectedItemsLead,
      selectedItemsOrderStatus: this.selectedItemsOrderStatus
    }
    this.sendFilterEvent.emit(data);
  }

  initCustomerIdGlobal() {
    let arrayIdGlobal: any[] = [];
    if (this.selectedItemsCustomer && this.selectedItemsCustomer.length > 0) {
      for (let elem of this.selectedItemsCustomer) {
        let key: string = elem.item_id;
        if (this.idLeadGlobalOfCustomerName) {
          let arrayIds = this.idLeadGlobalOfCustomerName.get(key);
          if (Array.isArray(arrayIds)) {
            for (let globalId of arrayIds) {
              let data: any = {
                item_id: globalId,
                item_text: globalId
              }
              let cust = arrayIdGlobal.find(x => x.item_id == data.item_id);
              if (!cust) {
                arrayIdGlobal.push(data);
              }

            }
          }
        }
      }
    }
    this.selectedItemsIdGlobal = arrayIdGlobal;
  }

  updateFiltersEvent() {
    let data: any = {
      selectedItemsOrderCluster: this.selectedItemsOrderCluster,
      selectedItemsYear: this.selectedItemsYear,
      selectedItemsMonth: this.selectedItemsMonth,
      selectedItemsCountry: this.selectedItemsCountry,
      selectedItemsCustomer: this.selectedItemsCustomer,
      selectedItemsOrderType: this.selectedItemsOrderType,
      selectedItemsBO: this.selectedItemsBO,
      selectedItemsIdGlobal: this.selectedItemsIdGlobal,
      selectedItemsLead: this.selectedItemsLead,
      selectedItemsOrderStatus: this.selectedItemsOrderStatus
    }
    this.updateFilterEvent.emit(data);
    this.loadReport();
  }

  onChangeSingleLead(event: any) {
    this.selectedItemsCustomer = [];
    this.selectedItemsBO = [];
    this.selectedItemsCountry = [];
    this.selectedItemsOrderType = [];
    this.selectedItemsOrderStatus = [];
    this.updateFiltersEvent();
  }





  onChangeSingleBo(event: any) {
    this.selectedItemsCountry = [];
    this.selectedItemsOrderType = [];
    this.selectedItemsOrderStatus = [];
    this.updateFiltersEvent();
  }





  onChangeSingleOrderStatus(event: any) {
    this.updateFiltersEvent();
  }







}
